import { Tag, TagCloseButton, TagLabel } from "@chakra-ui/react";
import React from "react";
import { VocabWord } from "../../../VocabModel";

interface WordChipProps {
  word: VocabWord;
  onClose: (word: VocabWord) => void;
  formattedWord: string;
}

export default function WordChip(props: WordChipProps) {
  const { word, onClose, formattedWord } = props;

  return (
    <Tag
      size={"md"}
      borderRadius="full"
      variant="solid"
      colorScheme="green"
      sx={{ background: "#F5F3EF", px: "0.75rem", py: "0.5rem" }}
      style={{ marginInline: 0 }}
    >
      <TagLabel sx={{ color: "#000" }}>{formattedWord}</TagLabel>
      <TagCloseButton onClick={() => onClose(word)} sx={{ color: "#000" }} />
    </Tag>
  );
}
